import * as api from '@gitbook/api-client';

export type MeterPrice = {
    /**
     * Label for the meter unit.
     */
    unitLabel: string;

    /**
     * Flat initial price in USD
     */
    flatInitialPrice: number;

    /**
     * The number of units at which the price per unit starts.
     */
    startingAt: number;

    /**
     * The number of units per batch.
     */
    unitsPerBatch: number;

    /**
     * The price per unit in USD.
     */
    pricePerBatch: number;

    /**
     * Description for the addon related to the meter.
     */
    addon?: {
        title: string;
        description: string;
        sellingPoints: string[];
    };
};

export const METER_PRICES: Record<api.BillingMeter, MeterPrice> = {
    [api.BillingMeter.AiResponses]: {
        unitLabel: 'Responses',
        startingAt: 0,
        unitsPerBatch: 1,
        pricePerBatch: 0,
        flatInitialPrice: 0,
    },
    [api.BillingMeter.AiAgentResponses]: {
        unitLabel: 'Responses',
        startingAt: 0,
        unitsPerBatch: 1,
        pricePerBatch: 0,
        flatInitialPrice: 0,
    },
    [api.BillingMeter.TranslationWords]: {
        unitLabel: 'Translated words',
        startingAt: 50000,
        unitsPerBatch: 1000,
        pricePerBatch: 0.2,
        flatInitialPrice: 25,
        addon: {
            title: 'Translations',
            description:
                'Generate AI translations of your content that automatically update whenever you make changes.',
            sellingPoints: [
                'Instantly reach new markets and boost your SEO.',
                `Maintain your brand voice across ${Object.values(api.TranslationLanguage).length} languages with AI-driven translations`,
                'Every content update is automatically reflected in all translations',
                'Save time and costs by eliminating manual translations',
                'Customize translations using a glossary or custom instructions',
            ],
        },
    },
};
